import React, { useEffect, useState } from 'react'
import { motion } from 'motion/react'
import { useLocale } from 'src/lib/hooks/useLocal'
import useNavigation from 'src/lib/hooks/useNavigation'
import PrimaryTabs from 'src/components/navigation/PrimaryNavBarComponents/PrimaryTabs'
import JourneyProgressTracker from 'src/components/navigation/PrimaryNavBarComponents/journey/JourneyProgressTracker'
import NavigationHeader from 'src/components/navigation/PrimaryNavBarComponents/NavigationHeader'
import NavigationFooter from 'src/components/navigation/PrimaryNavBarComponents/NavigationFooter'
import { useUser } from 'src/lib/contexts/UserContext'
import NavigationLoader from 'src/components/navigation/PrimaryNavBarComponents/loader/NavigationLoader'
import SearchComponent from 'src/components/navigation/SearchComponent'
import MarketingCard from 'src/components/navigation/PrimaryNavBarComponents/MarketingCard'

const PrimaryNavigationBar: React.FC = () => {
  const { t } = useLocale()
  const {
    getters: { sidebarOpen }
  } = useNavigation()
  const { isUserProfileLoading, user } = useUser()
  const [expandAnimationDone, setExpandAnimationDone] = useState(sidebarOpen)

  useEffect(() => {
    if (!sidebarOpen) {
      setExpandAnimationDone(false)
    }
  }, [sidebarOpen])

  return (
    <motion.nav
      className='rounded-xl shrink-0 bg-gray-100 h-full w-full'
      style={{
        boxShadow: 'inset 0px 0px 0px 1px rgba(0, 0, 0, 0.06)'
      }}
      id='primary-navigation-bar'
      layout
      animate={{
        width: sidebarOpen ? 270 : 52
      }}
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 40,
        mass: 1
      }}
      onAnimationComplete={() => {
        if (sidebarOpen) {
          setExpandAnimationDone(true)
        }
      }}
    >
      <motion.div layout className='flex flex-col h-full items-start w-full overflow-hidden overflow-x-hidden'>
        <NavigationHeader />
        {isUserProfileLoading && !user?.permissions?.length ? (
          <NavigationLoader />
        ) : (
          <>
            <SearchComponent />
            <div className='relative flex-1 min-h-0 w-full'>
              <div className='absolute inset-0 flex flex-col overflow-y-auto scrollbar-hide'>
                <PrimaryTabs />
                <JourneyProgressTracker />
                <MarketingCard show={expandAnimationDone} />
              </div>
            </div>
            <NavigationFooter />
          </>
        )}
      </motion.div>
    </motion.nav>
  )
}

export default PrimaryNavigationBar
